import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { useSession } from "../lib/session";

interface PageMeta {
  title: string;
  subtitle: string;
}

const PAGE_META: Record<string, PageMeta> = {
  "/input": { title: "Input Data", subtitle: "Isi dan kirim laporan Anda." },
  "/admin/dashboard": {
    title: "Dashboard",
    subtitle: "Grafik line harian, mingguan, dan bulanan.",
  },
  "/admin/master": {
    title: "Master Data",
    subtitle: "Referensi proyek & part dari Google Sheet.",
  },
  "/admin/harian": { title: "Harian", subtitle: "Data laporan harian tim." },
  "/admin/mingguan": { title: "Mingguan", subtitle: "Rekap laporan mingguan tim." },
  "/admin/tim": { title: "Data Tim", subtitle: "Data per tab tim." },
};

const FALLBACK_META: PageMeta = { title: "Dashboard", subtitle: "Laporan tim dan data." };

export function AppLayout() {
  const me = useSession();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  if (!me) {
    return null;
  }

  const meta = PAGE_META[location.pathname] ?? FALLBACK_META;

  return (
    <div className="min-h-full bg-bg transition-colors">
      <aside className="fixed inset-y-0 left-0 z-30 hidden w-72 bg-surface shadow-clay lg:block">
        <Sidebar role={me.role} />
      </aside>

      {menuOpen ? (
        <div className="fixed inset-0 z-40 lg:hidden">
          <button
            type="button"
            aria-label="Tutup menu"
            className="absolute inset-0 h-full w-full bg-black/40"
            onClick={() => setMenuOpen(false)}
          />
          <aside className="absolute inset-y-0 left-0 w-72 bg-surface shadow-clay">
            <Sidebar role={me.role} onNavigate={() => setMenuOpen(false)} />
          </aside>
        </div>
      ) : null}

      <div className="lg:pl-72">
        <div className="mx-auto flex min-h-screen max-w-[1400px] flex-col gap-6 px-4 py-6 sm:px-6 lg:px-8">
          <Topbar
            title={meta.title}
            subtitle={meta.subtitle}
            onOpenMenu={() => setMenuOpen(true)}
          />
          <main className="flex-1 pb-8">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
